import { useCallback, useRef, useState } from 'react'
import {
  getScrollTop,
  scrollToWithStickyObserve,
} from 'Components/hooks/use-scroll-sticky-observe'

// 展开收起场景在收起时正确设置滚动位置，避免内容塌陷
function useExpandAutoScroll<T extends HTMLElement>() {
  const [expanded, setExpanded] = useState(false)
  const heightRef = useRef(0)
  const rootRef = useRef<T | null>(null)

  const toggleExpand = useCallback(() => {
    setExpanded((prev) => {
      if (prev) {
        const { top, height } = rootRef.current!.getBoundingClientRect()
        if (top < 0) {
          scrollToWithStickyObserve(getScrollTop() + heightRef.current - height)
        }
      } else {
        heightRef.current = rootRef.current!.getBoundingClientRect().height
      }
      return !prev
    })
  }, [])

  return {
    expanded,
    setExpanded,
    toggleExpand,
    rootRef,
  }
}

export default useExpandAutoScroll
